/**
 * Created by jv on 04/05/2017.
 */
const moment = require("moment");
const utils = require("Sources/utils/utils");

module.exports = class SubscriptionHistory
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.comment = options.comment;
    
    this.correction = options.correction;
    this.grace = options.grace;

    this.validStart = options["valid-from"];
    this.validEnd = options["valid-until"];
  }

  set validStart(date)
  {
    this._validStart = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get validStart()
  {
    return utils.isMomentObject(this._validStart) ? this._validStart.format("DD-MM-YYYY") : null;
  }

  set validEnd(date)
  {
    this._validEnd = utils.isNullOrEmpty(date) ? null : moment(date, ["DD-MM-YYYY HH:mm:ss", moment.ISO_8601]);
  }

  get validEnd()
  {
    return utils.isMomentObject(this._validEnd) ? this._validEnd.format("DD-MM-YYYY") : null;
  }
}



// WEBPACK FOOTER //
// ./app/js/models/admin/subscription-history.js